<script setup lang="ts">

import { useShipStore } from '@/stores/shipStore.ts'
import { useI18n } from 'vue-i18n'
import { computed } from 'vue'

const { t } = useI18n()
const shipStore = useShipStore()

const tabs = computed(() => [
  {
    'id': 'ships',
    'name': t('command.tabs.ships'),
    'target' : '/command/ships',
    'activeKey': 'CommandShips'
  },
  {
    'id': 'fleets',
    'name': t('command.tabs.fleets'),
    'target' : '/command/fleets',
    'activeKey': 'CommandFleets'
  },
  {
    'id': 'designs',
    'name': t('command.tabs.shipDesigns'),
    'target' : '/command/ship-designs',
    'activeKey': 'CommandShipDesigns'
  },
  {
    'id': 'battle-simulator',
    'name': t('command.tabs.battleSimulator'),
    'target' : '/command/battle-simulator',
    'activeKey': 'CommandBattleSimulator'
  }
])

</script>

<template>
  <div class="text-sm font-medium text-center border-b text-gray-400 border-gray-700">
    <div class="overflow-x-auto whitespace-nowrap no-scrollbar">
      <ul class="flex">
      <li class="me-2">
        <router-link
          v-for="tab in tabs"
          :key="tab.name"
          :to="tab.target"
          :class="{
            'active-blue text-blue-500 border-blue-500': $route.name?.toString().startsWith(tab.activeKey),
            'text-gray-500 border-transparent': !$route.name?.toString().startsWith(tab.activeKey),
            'inline-block p-4 border-b-2 rounded-t-lg hover:border-gray-300 hover:text-gray-300': true
          }"
        >
          {{ tab.name }}
          <span v-if="tab.id === 'ships' && shipStore.countShipsWithoutFleet()>0" class="text-white">({{ shipStore.countShipsWithoutFleet() }})</span>
          <span v-if="tab.id === 'fleets' && shipStore.countFleetsWithShips()>0" class="text-white">({{ shipStore.countFleetsWithShips() }})</span>
        </router-link>
      </li>
    </ul>
    </div>
  </div>
  <router-view></router-view>
</template>

<style scoped lang="scss">
.active-blue {
  background: linear-gradient(
    to top,
    rgba(59, 130, 246, 0.3) 0%,
    rgba(59, 130, 246, 0) 70%
  );
}
</style>